import { useNavigationContext } from "./context.js";
import { composeHandlers, registerFocusListener, spatialItemHandler } from "@fiveway/core";
import { elementHandler } from "@fiveway/core/dom";
import { useEffect, useMemo, useRef } from "react";
//#region src/element.ts
/**
* Factory for creating {@link ElementHandler}.
*/
function useElementHandler() {
	const elementRef = useRef(null);
	return useMemo(() => {
		const handler = composeHandlers([elementHandler(() => elementRef.current), spatialItemHandler(() => {
			const rect = elementRef.current?.getBoundingClientRect();
			if (rect == null) return null;
			return {
				x: rect.left + rect.width * .5,
				y: rect.top + rect.height * .5
			};
		})]);
		handler.register = (element) => {
			elementRef.current = element;
		};
		return handler;
	}, []);
}
/**
* Hook that synchronizes native browser focus with focused node based on {@link elementHandler}.
*/
function useFocusSync() {
	const { tree } = useNavigationContext();
	useEffect(() => {
		let lastFocus = null;
		const el = elementHandler.query(tree, tree.focus);
		if (el != null) {
			lastFocus = tree.focus;
			el.focus();
		}
		const handler = () => {
			const el = elementHandler.query(tree, tree.focus);
			if (el != null) {
				lastFocus = tree.focus;
				el.focus();
				return;
			}
			if (lastFocus === null || !(document.activeElement instanceof HTMLElement)) return;
			const lastEl = elementHandler.query(tree, lastFocus);
			if (lastEl !== null && lastEl === document.activeElement) {
				document.activeElement.blur();
				lastFocus = null;
			}
		};
		return registerFocusListener(tree, "#", handler);
	}, [tree]);
}
//#endregion
export { useElementHandler, useFocusSync };

//# sourceMappingURL=element.js.map